import {
  withRoute,
  AnonymousRoute,
  withProtectedRoute,
  withRegionLockedRoute,
} from './Route';

export default withRoute;
export { AnonymousRoute, withProtectedRoute, withRegionLockedRoute };
